


































































































































import Company from "@/models/company";
import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import countries from "i18n-iso-countries";
import { UserModule } from "@/store/user";
import * as countriesEng from "i18n-iso-countries/langs/en.json";
import * as countriesEs from "i18n-iso-countries/langs/es.json";
import { get } from "lodash";
import { Select } from "@/models/general";
import { LayoutModule } from "@/store/layout";

@Component
export default class CompanyForm extends Vue {
  @Prop({ default: "companies.new_company" }) title!: string;
  @Prop() initialCompany?: Company;

  company: Company = new Company();

  countryList: Select[] = [];
  languageList: Select[] = [
    {
      text: this.$t("general.spanish").toString(),
      value: "es",
    },
    {
      text: this.$t("general.english").toString(),
      value: "en",
    },
  ];

  get loaderIsVisible(): boolean {
    return LayoutModule.loaderIsVisible;
  }

  created(): void {
    countries.registerLocale(get(countriesEng, "default"));
    countries.registerLocale(get(countriesEs, "default"));
    console.log(countries);

    Object.keys(countries.getNames(UserModule.getLang)).forEach((key) => {
      this.countryList.push({
        value: key,
        text: countries.getNames(UserModule.getLang)[key],
      });
    });

    if (this.initialCompany) this.company = new Company(this.initialCompany);
  }

  validate(): void {
    const validForm = (this.$refs.form as Vue & {
      validate: () => boolean;
    }).validate();
    validForm ? this.save() : null;
  }

  @Emit()
  save(): Company {
    return this.company;
  }

  @Emit()
  cancel(): null {
    return null;
  }
}
